import React, { useRef } from 'react';
import { Box, Icon, Text, Button, Modal, ModalBody, ModalHeader, ModalFooter, } from '@spothero/ui';
import { SearchComponent } from '@spothero/search-component';
import X from '@spothero/icons/x';
import { useSelector, useDispatch } from 'react-redux';
import { setSearchComponentEventView, setSearchComponentIsOpen, } from 'store/search/search-actions';
import { updateSearchComponentKey } from 'store/search-request/search-request-actions';
import { FindParkingSpotsButton } from '../../FindParkingSpotsButton';
const noOutlineStyles = {
    outline: 'none',
    boxShadow: 'none',
};
export const MobileSearchModal = () => {
    const initialFocusRef = useRef(null);
    const eventView = useSelector((state) => state.search.data.searchComponentEventView);
    const isOpen = useSelector((state) => state.search.data.searchComponentIsOpen);
    const headerTitle = useSelector((state) => state.header.data.headerTitle);
    const dispatch = useDispatch();
    const handleClose = () => {
        dispatch(setSearchComponentIsOpen(false));
        dispatch(setSearchComponentEventView(null));
        dispatch(updateSearchComponentKey());
    };
    const getLabel = () => {
        if (headerTitle)
            return headerTitle;
        if (eventView === 'select')
            return 'Change Event';
        if (eventView === 'selectWFilter')
            return 'Events';
        return 'Find Parking';
    };
    const label = getLabel();
    return (<Box>
            <Modal isOpen={isOpen} onClose={handleClose} size="full" hasHeader hasFooter hideCloseButton initialFocusRef={initialFocusRef} contentStyling={{
            sx: {
                '.SearchWidget': {
                    width: '100%',
                    // Prevents focus outline on the Toggle buttons in the SearchWidget
                    '& .chakra-button__group .chakra-button': noOutlineStyles,
                    '& .chakra-button__group .chakra-button:focus': noOutlineStyles,
                },
            },
            height: '100%',
        }}>
                <ModalHeader>
                    <Box>
                        <Text width="100%" textAlign="center" position="relative" fontWeight="semibold" fontSize="sm" ref={initialFocusRef}>
                            <Button variant="tertiary" color="black" onClick={handleClose} position="absolute" right="0" height="100%" data-testid="MobileSearchModal-close-button" aria-label="Close" tabIndex={-1} // Prevents focus from being set on the button when modal opens
    >
                                <Icon as={X} height="4.5" width="4.5"/>
                            </Button>
                            {label}
                        </Text>
                    </Box>
                </ModalHeader>
                {/* Overflow to prevent SearchComponent DatePicker from clipping by ModalFooter*/}
                <ModalBody overflow={eventView ? undefined : 'visible'} display={eventView ? 'inline' : 'flex'}>
                    <SearchComponent />
                </ModalBody>
                {!eventView && (<ModalFooter flexFlow="column" gap="4">
                        <FindParkingSpotsButton label="Confirm"/>
                        <Button variant="secondary" onClick={handleClose} width="100%" isFullWidth>
                            Cancel
                        </Button>
                    </ModalFooter>)}
            </Modal>
        </Box>);
};
